<app-auth-layout>
  @if(!showValidateCode && !showFormPassword){
    <div class="container">
      <h1>{{ resetPasswordContent()?.title }}</h1>
      <span>{{ resetPasswordContent()?.instructionsLabel }}</span>
      <form [formGroup]="formResetPasword" (ngSubmit)="onSubmit()">
        <div class="input-container">
          <input type="email" class="form-control" formControlName="email" required placeholder="Email"/>
        </div>
        @if (email?.invalid && (!email?.untouched || email?.dirty || submitted)) {
          <div class="text-alert">
            @if (email?.hasError('required')) {
              <ng-container class="container-error">
                <img src="/assets/icons/error.svg" alt="Icono" class="icon"/>
                {{ resetPasswordContent()?.emailRequiredError }}
              </ng-container>
            }
            @if (email?.hasError('email')) {
              <ng-container class="container-error">
                <img src="/assets/icons/error.svg" alt="Icono" class="icon"/>
                {{ resetPasswordContent()?.emailFormatError }}
              </ng-container>
            }
          </div>
        }
        <div class="container-buttons">
          <button type="button" (click)="onCancel()">{{ resetPasswordContent()?.cancelButton }}</button>
          <button type="submit" >{{ resetPasswordContent()?.nextButton }}</button>
        </div>
      </form>
    </div>
  }

</app-auth-layout>
